import React, { useState, useEffect, useCallback } from 'react';
import { FormControl, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import debounce from 'lodash.debounce';
import iq_api_v2 from '../../services/iqApiV2';
import { COMPANY_LOGO_BASE_URL } from '../../config/apiConfig';

const Autocomplete = ({autocomplete_for = "", value, onChange, placeholder, element_field_key, apiUrl, labelKey, valueKey }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [abortController, setAbortController] = useState(null);

  const [ulStyle, setUlStyle]  = useState({
            position: 'absolute',
            minWidth: '250px',
            listStyle: 'none',
            paddingLeft: '0',
            marginLeft: '5px',
            border: '1px solid #ccc',
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            zIndex: '1',
          })

    useEffect(() => {
      if(autocomplete_for == 'add_account'){
        setUlStyle({
            position: 'absolute',
            minWidth: '250px',
            listStyle: 'none',
            paddingLeft: '0',
            marginLeft: '0px',
            border: '1px solid #ccc',
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '4px',
            zIndex: '1',
            maxWidth: '760px',
            width: '760px',
            overflowX: "hidden",
            top: '38px',
          })
      }
    }, [autocomplete_for])
    

  const fetchSuggestions = useCallback(
    debounce(async (input) => {
      if (!input || input.length < 2) {
        setSuggestions([]);
        return;
      }

      // Abort previous request
      if (abortController) {
        abortController.abort();
      }

      const newController = new AbortController();
      setAbortController(newController);

      try {
        setLoading(true);

        if(autocomplete_for == 'add_account'){

          const response = await iq_api_v2.get(
              `${apiUrl}?search_string=${input}`,
              {
                headers: {
                  "Accept": "application/json",
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                signal: newController.signal, // ✅ added here
              }
            );

          setSuggestions(response.data || []);

        }else{
          const response = await api.get(`${apiUrl}/?query=${input}`, {
            signal: newController.signal,
          });

          // Example response handling
          setSuggestions(response.data.result.list || []);
        }
        
      } catch (err) {
        if (err.name === 'AbortError') {
          console.log('Request was aborted');
        } else {
          console.error('Failed to fetch suggestions:', err);
        }
      } finally {
        setLoading(false);
      }
    }, 300), // Add a 300ms debounce
    [apiUrl, abortController, autocomplete_for]
  );

  const handleChange = (e) => {
    const inputValue = e.target.value;
    onChange({ target: { value: inputValue, code: '', name: element_field_key, selected_data: '' } });

    if (inputValue.length >= 2) {
      fetchSuggestions(inputValue);
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (suggestion) => {
    onChange({ target: { value: suggestion[labelKey], code: suggestion[valueKey], name: element_field_key, selected_data:suggestion } });
    setSuggestions([]);
  };

  useEffect(() => {
    // Cleanup on unmount or when a new controller is set
    return () => {
      fetchSuggestions.cancel();
      if (abortController) {
        abortController.abort();
      }
    };
  }, [fetchSuggestions, abortController]);
  

  return (
    <div className={`${autocomplete_for == 'add_account' ? 'autocomplete_new' : 'autocomplete' }`} style={{ position: 'relative', display: "inline-block", width: "100%" }}>
      <FormControl
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        element_field_key={element_field_key}
      />
      {/* {loading && <div style={{ position: 'absolute', top: '100%', left: 0 }}>Loading...</div>} */}

      {loading && (
      <Spinner
          animation="border"
          size="sm"
          style={{
            position: "absolute",
            right: "15px",
            top: "30%",
            pointerEvents: "none",
          }}
      />
      )}

      {suggestions.length > 0 && (
        <ul
          className="suggestions-list"
          style={ulStyle}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              onClick={() => handleSelect(suggestion)}
              className="suggestion-item"
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #ddd',
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#f0f0f0';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '';
              }}
            >

              {autocomplete_for == 'add_account' ? (


                
                <div className='row'>
                {/* <span className='logo col-md-1' >
                  <img
                    width="30"
                    src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                      suggestion[labelKey]
                    )}`}
                    alt="image"
                    className="all_account_icon_img"
                  />
                </span> */}

                <div className='company_name  col-md-12'>
                  

                  <div className='row'>
                    <div className='col-md-10'>
                      <span className='' style={{
                         fontWeight: '600',
                         fontSize: '13px'
                      }}>{suggestion[labelKey]}</span>

                      {suggestion?.webpage &&
                      <>
                        {" "} · {" "} 
                        <span className='website font12 dark-grey'>{suggestion?.webpage }</span>
                      </>
                      }
                    </div>

                    <div className='col-md-2'>
                      <span className='website font12 dark-grey'> {suggestion?.companytypename } </span>
                    </div>
                    
                  </div>

                  {/* {suggestion?.webpage && <div className='row'>
                    <div className='col-md-12'>
                      {suggestion?.webpage &&
                      <>
                        {' '} 
                        <span className='website font12 dark-grey'>{suggestion?.webpage }</span>
                      </>
                      }
                    </div>
                  </div>
                  } */}

                  <div className='row'>
                    
                    <div className='col-md-12 '>
                      {suggestion?.country &&
                        <>
                          <span className='website font12 '>{suggestion?.country }</span>
                        </>
                        }

                        {suggestion?.yearfounded &&
                        <>
                         {" "} · <span className='website font12'>{suggestion?.yearfounded }</span>
                        </>
                        }

                        {suggestion?.industry &&
                        <>
                         {" "} · <span className='website font12'>{suggestion?.industry }</span>
                        </>
                        }
                    </div>


                  </div>

                  
                </div>
                
                </div>
              ) : (
                <>{suggestion[labelKey]}</>
              ) }

              
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Autocomplete;

